import React, { useEffect } from "react";
import { Link } from "react-router-dom";
// Removed import "../css/about.css";

export default function About() {
    useEffect(() => {
        window.scrollTo(0, 0);
    });

    return (
        // Main container and spacing
        <div className="container">

            {/* Breadcrumb Navigation */}
            <nav aria-label="breadcrumb" className="mt-4 mb-4">
                <ol className="breadcrumb">
                    {/* Home Link */}
                    <li className="breadcrumb-item">
                        <Link to="/" className="text-dark text-decoration-none">
                            <i className="fas fa-home me-2"></i> Home
                        </Link>
                    </li>
                    <li className="breadcrumb-item">
                        <i className="fa-regular fa-folder me-2"></i> About
                    </li>
                </ol>
            </nav>

            {/* === Section 1: Image and Welcome Message (Side-by-Side) === */}
            <div className="row align-items-center mb-5 gx-5 mt-5">

                {/* Left Image Section */}
                <div className="col-lg-6 mb-4 mb-lg-0">
                    <div className="p-2 bg-light rounded-4 shadow-lg">
                        <img
                            src="/images/banners/about.jpg"
                            alt="Home Decor and Furniture"
                            className="img-fluid rounded-4"
                        />
                    </div>
                </div>

                {/* Right Content Section */}
                <div className="col-lg-6">
                    <h2 className="fw-bold mb-4 text-dark fs-1">About Our Journey</h2>

                    <p className="lead text-muted">
                        Welcome to Online Shop Matrix — where design, comfort, and innovation
                        come together. We are dedicated to offering you a seamless and enjoyable
                        shopping experience filled with products that elevate your home and lifestyle.
                    </p>

                    <p className="text-secondary">
                        Our journey began with a passion for creating spaces that feel warm,
                        functional, and stylish. We’ve built partnerships with trusted brands and
                        artisans to curate a diverse range of products that blend quality with
                        affordability.
                    </p>

                    <p className="text-secondary">
                        Every collection we introduce reflects our core philosophy — that good design
                        should be accessible to everyone. Our team handpicks every product after
                        rigorous quality checks to ensure it meets the highest standards of durability,
                        craftsmanship, and design.
                    </p>
                </div>
            </div>
            {/* End Section 1 */}

            {/* === Section 2: Mission, Vision, and Values === */}
            <div className="row mt-5 pt-4">
                <div className="col-md-4 mb-4">
                    <h4 className="fw-bold text-primary mb-3">Our Mission</h4>
                    <p className="text-secondary">
                        To make shopping smarter, faster, and more enjoyable. We aim to create an
                        online space where every customer can find quality products, great deals, and an
                        experience that exceeds expectations.
                    </p>
                </div>

                <div className="col-md-4 mb-4">
                    <h4 className="fw-bold text-primary mb-3">Our Vision</h4>
                    <p className="text-secondary">
                        Online Shop Matrix envisions becoming a globally recognized marketplace that sets
                        new standards in digital retail innovation, customer care, and sustainability.
                    </p>
                </div>

                <div className="col-md-4 mb-4">
                    <h4 className="fw-bold text-primary mb-3">Our Core Values</h4>
                    <ul className="list-unstyled">
                        <li className="mb-2 text-secondary">
                            <i className="fa-solid fa-check-circle text-success me-2"></i> Integrity and Transparency.
                        </li>
                        <li className="mb-2 text-secondary">
                            <i className="fa-solid fa-check-circle text-success me-2"></i> Quality First in product selection.
                        </li>
                        <li className="mb-2 text-secondary">
                            <i className="fa-solid fa-check-circle text-success me-2"></i> Customer Focus and Trust.
                        </li>
                    </ul>
                </div>
            </div>
            {/* End Section 2 */}

            {/* === Section 3: Commitment and Sustainability === */}
            <div className="row mt-5 pt-4 border-top mb-5">
                <div className="col-12">
                    <h4 className="fw-bold text-dark mb-3">Our Commitment to Sustainability</h4>
                    <p className="text-secondary fs-6">
                        We prioritize eco-conscious suppliers and packaging methods that reduce waste
                        and protect the environment. We believe that a beautiful home should never come
                        at the expense of a beautiful planet.
                    </p>
                    <p className="mt-4 mb-0 text-primary fw-semibold fs-5">
                        Thank you for trusting us. Shop smarter, live better — with Online Shop Matrix.
                    </p>
                </div>
            </div>
        </div>
    );
}